import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import useStyles from "../styles/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "common/sharedFunctions";
import { useNavigate } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";

const LandingInfo = () => {
  const classes = useStyles();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box className={classes.centerContainer}>
      <Grid container spacing={3} className={classes.aboutUsContainer}>
        <Grid item xs={12} md={12} style={{ position: "relative" }}>
          <div
            style={{
              margin: "0px auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                margin: "0px auto",
                flex: "1",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h4"
                fontWeight={700}
                fontFamily={FONT_FAMILY}
                className={classes.homeTitle}
              >
                {t("mobile_apps_on_store")}
              </Typography>
            </div>
            <div
              style={{
                margin: "0px auto",
                flex: "1",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  margin: "0px auto",
                  flex: "1",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <Button
                  className={classes.primaryButton}
                  color="facebook"
                  size="lg"
                  sx={{
                    width: "290px",
                    margin: "9px 8px",
                    fontFamily: FONT_FAMILY,
                    fontSize: "15px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/bookings");
                  }}
                >
                  {t("book_your_ride_menu")}
                </Button>
              </div>
            </div>
            <div
              style={{
                margin: "0px auto",
                flex: "1",
                justifyContent: "center",
              }}
            ></div>
            {settings && settings.AppleStoreLink ? (
              <div
                style={{
                  margin: "0px auto",
                  flex: "1",
                  justifyContent: "center",
                }}
              >
                <a href={settings.AppleStoreLink}>
                  <img
                    src={require("../assets/img/appstore.png").default}
                    alt="Apple Store Link"
                  />
                </a>
                <a href={settings.PlayStoreLink} style={{ marginLeft: "10px" }}>
                  <img
                    src={require("../assets/img/playstore.png").default}
                    alt="Playstore Link"
                  />
                </a>
              </div>
            ) : null}
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LandingInfo;
